import React, { Suspense, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Loading } from 'aha-components';

const OnboardingHome = React.lazy(
  () =>
    import(/* webpackChunkName: "page~onboarding~OnboardingHome" */ './index')
);

const OnboardingLoadError: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center gap-4 px-4 text-center">
      <p className="text-base text-gray-700">
        {t('common.page_load_failed', {
          defaultValue: 'This page could not be loaded. Please try again.'
        })}
      </p>
      <button
        type="button"
        className="rounded bg-[#FB6011] px-5 py-2 text-white"
        onClick={() => window.location.reload()}
      >
        {t('common.reload_page', { defaultValue: 'Reload page' })}
      </button>
    </div>
  );
};

export const OnboardingLoading: React.FC = () => {
  const { t } = useTranslation();
  const [showReload, setShowReload] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => setShowReload(true), 12_000);
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center gap-4">
      <Loading width={50} height={50} color="#000" />
      {showReload && (
        <button
          type="button"
          className="rounded bg-[#FB6011] px-5 py-2 text-white"
          onClick={() => window.location.reload()}
        >
          {t('common.reload_page', { defaultValue: 'Reload page' })}
        </button>
      )}
    </div>
  );
};

class OnboardingLoadErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    console.error('Failed to load onboarding:', error);
  }

  render() {
    if (this.state.hasError) {
      return <OnboardingLoadError />;
    }

    return this.props.children;
  }
}

const OnboardingRoute: React.FC = () => (
  <OnboardingLoadErrorBoundary>
    <Suspense fallback={<OnboardingLoading />}>
      <OnboardingHome />
    </Suspense>
  </OnboardingLoadErrorBoundary>
);

export default OnboardingRoute;
